/**
 * Client-side attestation helpers. Wording and active versions come from
 * GET /signing/attestations/active — use `useActiveAttestations` + helpers below.
 */

export type AttestationFamily = 'visit' | 'order' | 'cms485';

/** Single attestation block (matches API `AttestationContentResponse`). */
export interface SigningAttestation {
  version: string;
  text: string;
}

/** Map returned by GET /signing/attestations/active. */
export type ActiveAttestationsMap = Record<
  AttestationFamily,
  SigningAttestation
>;

export function resolveAttestationFamily(
  taskType: 'visit' | 'order',
  orderType?: string | null
): AttestationFamily {
  if (taskType === 'visit') return 'visit';
  if (orderType === 'CMS_485') return 'cms485';
  return 'order';
}

export function selectAttestationForFamily(
  map: ActiveAttestationsMap,
  family: AttestationFamily
): SigningAttestation {
  return map[family];
}
